import { configureStore } from "@reduxjs/toolkit";
import sapeagleOrderReducer from "./slices/sapeagleOrderSlice";
import blogReducer from "./slices/blogSlice";
export const store = configureStore({
    reducer:{
        sapeagleOrder: sapeagleOrderReducer,
          blog: blogReducer,
    }
})